(function () {
    function copyToClipboard(text) {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text);
        }

        return new Promise(function (resolve, reject) {
            var textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'fixed';
            textarea.style.left = '-9999px';
            document.body.appendChild(textarea);
            textarea.select();

            try {
                if (document.execCommand('copy')) {
                    resolve();
                } else {
                    reject();
                }
            } catch (err) {
                reject(err);
            } finally {
                document.body.removeChild(textarea);
            }
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        var shareBtn = document.querySelector('.gh-button-share');
        if (!shareBtn) {
            return;
        }

        var url = shareBtn.getAttribute('data-share-url') || window.location.href;
        var defaultLabel = shareBtn.textContent.trim();
        var copiedLabel = shareBtn.getAttribute('data-copied-label') || 'Copied!';

        shareBtn.addEventListener('click', function (event) {
            event.preventDefault();

            copyToClipboard(url).then(function () {
                shareBtn.textContent = copiedLabel;
                shareBtn.classList.add('is-copied');
                shareBtn.setAttribute('aria-label', copiedLabel);

                window.setTimeout(function () {
                    shareBtn.textContent = defaultLabel;
                    shareBtn.classList.remove('is-copied');
                    shareBtn.setAttribute('aria-label', defaultLabel);
                }, 2000);
            }).catch(function () {
                window.prompt(defaultLabel + ':', url);
            });
        });
    });
})();
